import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  private isLoadingSubjectDisabled:boolean = false;
  isLoading$ = this.isLoadingSubject.asObservable();

  disableLoading(shouldDisable: boolean = false) {
    this.isLoadingSubjectDisabled = shouldDisable;
  }

  isDisabled(){
    return this.isLoadingSubjectDisabled;
  }

  show() {
    this.isLoadingSubject.next(true);
  }

  hide() {
    this.isLoadingSubject.next(false);
  }
}
